export async function apiRequest<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    ...init,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...init?.headers,
    },
  })

  if (res.status === 401) {
    // Пробуем обновить токен
    const refreshed = await fetch('/api/users/refresh-token', {
      method: 'POST',
      credentials: 'include',
    })

    if (refreshed.ok) {
      // Повторяем оригинальный запрос с новым токеном
      const retry = await fetch(path, {
        ...init,
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          ...init?.headers,
        },
      })
      if (retry.ok) return retry.json() as Promise<T>
    }

    // Refresh не помог — редирект на логин
    window.location.href = '/admin/login'
    return Promise.reject(new Error('Unauthorized'))
  }

  if (!res.ok) {
    const text = await res.text().catch(() => res.statusText)
    throw new Error(`API ${res.status}: ${text}`)
  }

  return res.json() as Promise<T>
}